import { registerFr } from '../i18n/index.js';

registerFr({
  'Inbox': 'Boîte de réception',
  'every thread is a touchpoint': 'chaque fil est un point de contact',
  'synced': 'synchronisé',
  'IMAP idle': 'IMAP en veille',
  'drop folder only': 'dossier de dépôt seulement',
  'sender in stub mode · approved mail is written to {dir}':
    'expéditeur en mode stub · le courriel approuvé est écrit dans {dir}',
  'sender is SMTP · approved mail actually leaves': 'expéditeur SMTP · le courriel approuvé part réellement',
  'the sender has not answered yet': 'l’expéditeur n’a pas encore répondu',

  // rail
  'Needs me': 'Requiert mon attention',
  'threads whose last message came in and is unanswered':
    'fils dont le dernier message est entrant et sans réponse',
  'Unknown': 'Inconnus',
  '{n} with a domain that matches an organisation': '{n} avec un domaine qui correspond à une organisation',
  'Drafts': 'Brouillons',
  'held proposals waiting for a send': 'propositions retenues en attente d’envoi',
  'Outbox': 'Boîte d’envoi',
  'stub': 'stub',
  'written to data/outbox/, not sent': 'écrit dans data/outbox/, non envoyé',
  'sent through SMTP': 'envoyé par SMTP',
  'Threads · 7d': 'Fils · 7 j',
  '{in} in · {out} out · median reply {h}': '{in} entrants · {out} sortants · réponse médiane {h}',
  'the summary has not answered yet': 'le récapitulatif n’a pas encore répondu',
  'Unknown senders': 'Expéditeurs inconnus',

  // the panes
  'The mailbox': 'La messagerie',
  'The mailbox could not be read': 'La messagerie n’a pas pu être lue',
  'All': 'Tous',
  '{n} message': '{n} message',
  '{n} messages': '{n} messages',
  'unknown': 'inconnu',
  'unknown sender': 'expéditeur inconnu',
  '(no subject)': '(sans objet)',
  'us · late': 'nous · en retard',
  'No sender is waiting for a judgement.': 'Aucun expéditeur n’attend de décision.',
  'Nothing is waiting on you. Every thread was last answered by you.':
    'Rien ne vous attend. Chaque fil a reçu votre réponse en dernier.',
  'No mail has been imported yet. Drop an .eml into the drop folder, or configure MAIL_IMAP_HOST.':
    'Aucun courriel n’a encore été importé. Déposez un .eml dans le dossier de dépôt, ou renseignez MAIL_IMAP_HOST.',
  'Choose a thread on the left.': 'Choisissez un fil à gauche.',
  'The thread could not be read': 'Le fil n’a pas pu être lu',

  // triage
  'Unknown sender': 'Expéditeur inconnu',
  'matches': 'correspond à',
  'by domain': 'par le domaine',
  'matches no organisation on the record': 'ne correspond à aucune organisation du dossier',
  'Create person': 'Créer la personne',
  'Attach to existing…': 'Rattacher à une personne existante…',
  'Attach to an existing person': 'Rattacher à une personne existante',
  'Ignore domain': 'Ignorer le domaine',
  'Name, organisation, email…': 'Nom, organisation, courriel…',
  'Type at least two characters.': 'Saisissez au moins deux caractères.',
  'No person matches that.': 'Aucune personne ne correspond.',
  'This address has written {n} times since {date}. Nothing about it has entered the record: no person, no interaction. Creating a person files a proposal in your name and holds it in the same click, so the ledger says who decided.':
    'Cette adresse a écrit {n} fois depuis le {date}. Rien n’en est entré au dossier : ni personne, ni point de contact. « Créer la personne » dépose une proposition en votre nom et la retient dans le même clic, pour que le journal dise qui a décidé.',
  'Person created and the thread linked.': 'Personne créée et fil rattaché.',
  'The address is now on {name}.': 'L’adresse est désormais rattachée à {name}.',
  'The domain is ignored.': 'Le domaine est ignoré.',

  // the thread
  'messages': 'messages',
  'ball · us': 'balle · nous',
  'ball · them': 'balle · eux',
  'd': 'j',
  '(this message carried no text part)': '(ce message ne portait aucune partie texte)',
  'Draft reply': 'Brouillon de réponse',
  'words': 'mots',
  'Send (stub)': 'Envoyer (stub)',
  'Send': 'Envoyer',
  'Amend in Review →': 'Amender dans la revue →',
  'Amend →': 'Amender →',
  'writes an .eml into data/outbox/ and marks the row written':
    'écrit un .eml dans data/outbox/ et marque la ligne « écrit »',
  'leaves through SMTP and marks the row sent': 'part par SMTP et marque la ligne « envoyé »',
  'The message was written to the outbox.': 'Le message a été écrit dans la boîte d’envoi.',

  // zones
  'Drafts to approve': 'Brouillons à approuver',
  'held proposals · nothing here has been sent': 'propositions retenues · rien n’a été envoyé',
  'Review →': 'Revue →',
  'No draft is waiting': 'Aucun brouillon n’attend',
  'A row appears here when you hold a `draft` proposal: the applier writes one outbox row, status approved. Holding a draft is not sending it — sending is the button on the row.':
    'Une ligne apparaît ici lorsque vous retenez une proposition `draft` : l’applicateur écrit une seule ligne de boîte d’envoi, statut approuvé. Retenir un brouillon n’est pas l’envoyer — l’envoi, c’est le bouton sur la ligne.',
  'Outbox and sent': 'Boîte d’envoi et envoyés',
  'stub sender · nothing left this machine': 'expéditeur stub · rien n’a quitté cette machine',
  'SMTP sender': 'expéditeur SMTP',
  'Subject': 'Objet',
  'To': 'À',
  'Status': 'Statut',
  'Sent': 'Envoyé',
  'File': 'Fichier',
  'written': 'écrit',
  'sent': 'envoyé',
  'failed': 'échoué',
  'approved': 'approuvé',
  'Nothing has been sent': 'Rien n’a été envoyé',
  'A row lands here after you send an approved draft. With the stub sender the bytes are written to data/outbox/ and the row reads written, not sent — the difference is the point.':
    'Une ligne arrive ici après l’envoi d’un brouillon approuvé. Avec l’expéditeur stub, les octets sont écrits dans data/outbox/ et la ligne indique « écrit », non « envoyé » — c’est précisément la différence qui compte.',
  'Reading the thread — what it finds arrives in Review.':
    'Lecture du fil — ce qu’elle trouve arrive dans la revue.',
}, 'InboxPage');
